import { ButtonLevels } from '@zipari/shared-ds-util-button';
import { ModalTypes } from '@zipari/shared-ds-util-modal';
import { ActionButtonMetaConfig } from './action-button.constants';

export const mockActionButtonConfig: ActionButtonMetaConfig = {
  actionButton: {
    leftIcon: 'download',
    rightIcon: '',
    label: 'Actions',
    level: ButtonLevels.low,
  },
  actions: [
    {
      label: 'Google',
      icon: 'close',
      useExternalSiteModal: true,
      externalLink: 'https://google.com',
      externalSiteModalConfig: {
        title: 'title',
        description: 'description',
        footerCancelButton: 'Cancel',
        footerProceedButton: 'Proceed',
        type: ModalTypes.popup,
        backdrop: true,
        clickOutside: true,
        header: {
          title: null,
          icon: null,
          showClose: null,
        },
        altStyle: false,
      },
    },
    {
      label: 'Add Notes',
      icon: 'close',
    },
    {
      label: 'Download a PDF of this claim',
      icon: 'close',
    },
  ],
};
